/* ---------------------------------------------------------------------------
   app.js — TFx Reimagined theme behaviors.
   Verb rotation, sticky header, scroll-spy, FAQ accordion, mini-cart drawer,
   product card variant selection, Build Your Stack, mobile nav.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CONFIG = window.TFX_CONFIG || { freeShippingCents: 5000, routes: { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart' }, stackDiscountCode: 'STACK15' };

  // ---------- Utility ----------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    // Simple USD format; Shopify's money filter handles server-side rendering elsewhere.
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  // ---------- 1. Hero verb rotation ----------
  function initVerbRotation() {
    var verbEl = $('[data-verb-list]');
    if (!verbEl) return;
    var verbs = (verbEl.dataset.verbList || '').split(',').map(function (v) { return v.trim(); }).filter(Boolean);
    if (verbs.length < 2) return;
    var idx = 0;
    setInterval(function () {
      verbEl.style.opacity = '0';
      verbEl.style.transform = 'translateY(-8px)';
      setTimeout(function () {
        idx = (idx + 1) % verbs.length;
        verbEl.textContent = verbs[idx];
        verbEl.style.opacity = '1';
        verbEl.style.transform = 'translateY(0)';
      }, 200);
    }, 3000);
  }

  // ---------- 4 & 5. Scroll-spy nav + sticky header shrink ----------
  function initHeaderBehaviors() {
    var header = $('.header');
    if (!header) return;

    // Sentinel for shrink-on-scroll
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:80px;left:0;height:1px;width:1px;pointer-events:none;';
    document.body.appendChild(sentinel);

    if ('IntersectionObserver' in window) {
      var shrinkIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) header.classList.remove('header--scrolled');
          else header.classList.add('header--scrolled');
        });
      });
      shrinkIO.observe(sentinel);
    }

    // Scroll-spy on sections referenced by nav links with data-section attrs
    var navLinks = $$('.header__nav-link[data-section]');
    if (!navLinks.length || !('IntersectionObserver' in window)) return;

    var sectionMap = {};
    navLinks.forEach(function (link) {
      var id = link.dataset.section;
      var sec = document.getElementById(id);
      if (sec) sectionMap[id] = { link: link, section: sec };
    });

    var spyIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.id;
        if (!sectionMap[id]) return;
        if (entry.isIntersecting) {
          navLinks.forEach(function (l) { l.classList.remove('is-active'); });
          sectionMap[id].link.classList.add('is-active');
        }
      });
    }, { threshold: 0.3, rootMargin: '-80px 0px -50% 0px' });

    Object.keys(sectionMap).forEach(function (id) {
      spyIO.observe(sectionMap[id].section);
    });
  }

  // ---------- Mobile nav ----------
  function initMobileNav() {
    var toggle = $('[data-mobile-nav-toggle]');
    var close = $('[data-mobile-nav-close]');
    var overlay = $('[data-mobile-nav]');
    if (!toggle || !overlay) return;
    toggle.addEventListener('click', function () { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    if (close) close.addEventListener('click', function () { overlay.classList.remove('is-open'); document.body.style.overflow = ''; });
    $$('.mobile-nav__link', overlay).forEach(function (l) {
      l.addEventListener('click', function () { overlay.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
  }

  // ---------- FAQ accordion ----------
  function initFAQ() {
    $$('.faq-item').forEach(function (item) {
      var trigger = $('.faq-item__trigger', item);
      var panel = $('.faq-item__panel', item);
      if (!trigger || !panel) return;
      trigger.addEventListener('click', function () {
        var open = item.getAttribute('aria-expanded') === 'true';
        // Close all
        $$('.faq-item').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var op = $('.faq-item__panel', other);
          if (op) op.style.maxHeight = '0px';
        });
        if (!open) {
          item.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  // ---------- Product card flavor pills ----------
  function initVariantPills() {
    $$('.product-card').forEach(function (card) {
      var pills = $$('.variant-pill', card);
      if (!pills.length) return;
      var addBtn = $('[data-add-to-cart]', card);
      var priceEl = $('[data-price]', card);
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          if (addBtn) addBtn.dataset.variantId = pill.dataset.variantId;
          if (priceEl && pill.dataset.price) priceEl.textContent = formatMoney(parseInt(pill.dataset.price, 10));
        });
      });
    });
  }

  // ---------- Mini cart drawer ----------
  var CartDrawer = {
    el: null,
    init: function () {
      this.el = $('.mini-cart');
      if (!this.el) return;
      var self = this;
      $$('[data-mini-cart-close], .mini-cart__backdrop').forEach(function (n) {
        n.addEventListener('click', function () { self.close(); });
      });
      // Open via header cart icon
      $$('[data-mini-cart-open]').forEach(function (n) {
        n.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
      });
      // Line item quantity + remove
      this.el.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cart-action]');
        if (!t) return;
        e.preventDefault();
        var action = t.dataset.cartAction;
        var line = parseInt(t.dataset.line, 10);
        var qty = parseInt(t.dataset.qty || '0', 10);
        if (action === 'remove') self.changeLine(line, 0);
        else if (action === 'inc') self.changeLine(line, qty + 1);
        else if (action === 'dec' && qty > 1) self.changeLine(line, qty - 1);
      });
    },
    open: function () { if (this.el) { this.el.classList.add('is-open'); document.body.style.overflow = 'hidden'; } },
    close: function () { if (this.el) { this.el.classList.remove('is-open'); document.body.style.overflow = ''; } },
    refresh: function () {
      var self = this;
      return fetch('/?section_id=mini-cart', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-section-id="mini-cart"]');
          var current = document.querySelector('[data-section-id="mini-cart"]');
          if (fresh && current) {
            var wasOpen = self.el && self.el.classList.contains('is-open');
            current.replaceWith(fresh);
            self.el = $('.mini-cart');
            self.init();
            if (wasOpen) self.open();
          }
          updateHeaderCartCount();
        });
    },
    add: function (variantId, quantity) {
      var self = this;
      return fetch(CONFIG.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      }).then(function () {
        return self.refresh().then(function () { self.open(); });
      });
    },
    addMulti: function (items) {
      var self = this;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { return self.refresh(); });
    },
    changeLine: function (line, qty) {
      var self = this;
      return fetch(CONFIG.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { return self.refresh(); });
    }
  };

  function updateHeaderCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.header__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });
      })
      .catch(function () { /* swallow */ });
  }

  // ---------- Bind add-to-cart buttons ----------
  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.dataset.variantId;
      if (!id) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'ADDING…';
      CartDrawer.add(parseInt(id, 10), 1)
        .catch(function () { btn.textContent = 'TRY AGAIN'; })
        .then(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

  // ---------- Build Your Stack ----------
  function initBuildYourStack() {
    var module = $('[data-stack]');
    if (!module) return;
    var items = $$('[data-stack-item]', module);
    var counterEl = $('[data-stack-count]', module);
    var cta = $('[data-stack-cta]', module);
    var selections = [];

    function update() {
      if (counterEl) counterEl.textContent = selections.length;
      if (cta) cta.disabled = selections.length !== 3;
    }
    update();

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var id = item.dataset.variantId;
        if (!id) return;
        var idx = selections.indexOf(id);
        if (idx > -1) {
          selections.splice(idx, 1);
          item.classList.remove('is-selected');
        } else if (selections.length < 3) {
          selections.push(id);
          item.classList.add('is-selected');
        }
        update();
      });
    });

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (selections.length !== 3) return;
        var payload = selections.map(function (vid) { return { id: parseInt(vid, 10), quantity: 1 }; });
        cta.disabled = true;
        cta.textContent = 'ADDING…';
        CartDrawer.addMulti(payload).then(function () {
          window.location.href = '/checkout?discount=' + encodeURIComponent(CONFIG.stackDiscountCode);
        });
      });
    }
  }

  // ---------- Init all ----------
  function init() {
    initVerbRotation();
    initHeaderBehaviors();
    initMobileNav();
    initFAQ();
    initVariantPills();
    CartDrawer.init();
    initAddToCart();
    initBuildYourStack();
    updateHeaderCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for snippets/sections
  window.TFX = window.TFX || {};
  window.TFX.CartDrawer = CartDrawer;
})();
